import { Helmet } from 'react-helmet';
import { StaffViewContainer } from '../components/staff-view.container';
import { useParams } from 'react-router-dom';


export const StaffView: React.FC = () => {
const { staffId } = useParams();

  return (
    <>
      <Helmet>
        <title>Staff Details</title>
      </Helmet>
      <StaffViewContainer staffUserId={staffId ?? ''} />
    </>
  );
};
